var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendingDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60003 10.4C9.38786 10.4 9.18438 10.4843 9.03435 10.6343C8.88432 10.7843 8.80003 10.9878 8.80003 11.2C8.80003 11.4122 8.88432 11.6157 9.03435 11.7657C9.18438 11.9157 9.38786 12 9.60003 12H13.6C13.8122 12 14.0157 11.9157 14.1657 11.7657C14.3157 11.6157 14.4 11.4122 14.4 11.2V7.2C14.4 6.98782 14.3157 6.78434 14.1657 6.63431C14.0157 6.48428 13.8122 6.4 13.6 6.4C13.3879 6.4 13.1844 6.48428 13.0343 6.63431C12.8843 6.78434 12.8 6.98782 12.8 7.2V9.2688L9.36563 5.8344C9.21561 5.68442 9.01216 5.60017 8.80003 5.60017C8.5879 5.60017 8.38446 5.68442 8.23443 5.8344L6.40003 7.6688L2.96563 4.2344C2.81475 4.08867 2.61267 4.00803 2.40291 4.00986C2.19315 4.01168 1.9925 4.09581 1.84418 4.24414C1.69585 4.39247 1.61172 4.59312 1.60989 4.80288C1.60807 5.01263 1.68871 5.21471 1.83443 5.3656L5.83443 9.3656C5.98446 9.51557 6.1879 9.59983 6.40003 9.59983C6.61216 9.59983 6.81561 9.51557 6.96563 9.3656L8.80003 7.5312L11.6688 10.4H9.60003Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingDown);
export default __webpack_public_path__ + "static/media/TrendingDown.682171be08c597658bf5a95ac4e3fcb3.svg";
export { ForwardRef as ReactComponent };